import { Component, OnInit, ErrorHandler } from '@angular/core';
import { RegistrationService } from '../../../registration.service';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-military-operation-grid',
  templateUrl: './military-operation-grid.component.html',
  styleUrls: ['./military-operation-grid.component.css']
})
export class MilitaryOperationGridComponent implements OnInit {
  maintitle="Military Operations";
  title = "View Military Operations";
  totalItems: number;
  itemsPerPage: number=5 ;
  currentPage: number=1;
  moList: any=[];
  constructor(private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) {

   }

  ngOnInit() {
    this.GetAllMilitaryOperations(this.itemsPerPage, 1);
  }


   SetUrl(Mil_OperationId:any,mode:any)
  {
    localStorage.setItem('Mil_OperationId',Mil_OperationId);
    localStorage.setItem('mode', mode);
  }

  pageChanged(pageNumber: number) {
    // if (this.isSearch)
    //   this.onSearch(this.s, this.itemsPerPage, pageNumber);
    // else
      this.GetAllMilitaryOperations(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    // if (this.isSearch)
    //   this.onSearch(this.s, this.itemsPerPage, pageNo);
    // else
      this.GetAllMilitaryOperations(this.itemsPerPage, pageNo);
  }

  GetAllMilitaryOperations(itemsPerPage: number, pageNo: number) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllMilitaryOperations(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.moList = data.MOList;
          console.log(data);
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  
  DeleteMilitaryOperation(Mil_OperationId:any)
  {
    
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deleteMilitaryOperation(Mil_OperationId).subscribe(
          (data:any) => {
            swal('','Military Operation has been Deleted!','success');
            this.GetAllMilitaryOperations(this.itemsPerPage, 1);
            // this.s.SearchText = "";
            // this.s.SearchCriteria = "";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.handleError(error);
          });
      }
    })  
  }


}



// WEBPACK FOOTER //
// ./src/app/Masters/military-operations/military-operation-grid/military-operation-grid.component.ts